import { render, staticRenderFns } from "./DeleteReward.vue?vue&type=template&id=4c9b9764&scoped=true&"
import script from "./DeleteReward.vue?vue&type=script&lang=js&"
export * from "./DeleteReward.vue?vue&type=script&lang=js&"
import style0 from "./DeleteReward.vue?vue&type=style&index=0&id=4c9b9764&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9b9764",
  null
  
)

export default component.exports